/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const addUserBatchTag = params => {
  return axios.post(`${base}/add_user_batch_tag`, params)
}
export const delUserBatchTag = params => {
  return axios.post(`${base}/delete_user_batch_tag`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-batch-tag/user-batch-tag.api.js